const colors = {
  brand: {
    50: '#e6f7f5',
    100: '#b3e8e2',
    200: '#80d9cf',
    300: '#4dcabc',
    400: '#26bfad',
    500: '#3cb7a0',
    600: '#2ea08b',
    700: '#228574',
    800: '#176a5c',
    900: '#0d4f45',
    // 2026-09-02 대표 지시 — 레이블리 로고(`public/laeebly-icon.png`) 실측 채움색.
    // 작품 카드의 「일반 채널」 배지가 이 값을 쓴다(WorkCard TONE.scopeOpen). 로고 파일을 바꾸면 여기도 맞출 것.
    logo: '#2faea3',
  },
  neutral: {
    50: '#fafaf8',
    100: '#f5f4f0',
    200: '#eae8e3',
    300: '#d4d1ca',
    400: '#a09c94',
    500: '#7a7670',
    600: '#5c5856',
    700: '#3d3b39',
    800: '#262524',
    900: '#1a1918',
    950: '#111010',
  },
  accent: {
    50: '#fdf6e8',
    100: '#f9e8c4',
    200: '#f2d08a',
    300: '#e4b44e',
    400: '#d49a2a',
    500: '#c2841a',
    600: '#a06c14',
    700: '#7d5310',
    800: '#5a3c0b',
    900: '#3d2907',
  },
  // 2026-08-30 신규 — 크리에이터 등급(티어) 심볼 전용 색. 알파 UI 확정 패키지(PR #141) 반입,
  // 값은 원본 그대로(WCAG AA 대비 실측 통과값이라 손대지 않았다). base = 심볼 채움 기준색,
  // ink = 등급명 텍스트(흰 배경 대비 4.5:1 이상), chip = 24px 이하 폴백의 배경칩.
  // 통용 금속색(실버 #c0c0c0 1.85:1, 골드 #ffd700 1.31:1, 플래티넘 #e5e4e2 1.24:1)은 전부 AA
  // 미달이라 쓰지 않는다 — `src/lib/tierSymbols.js`(한글 등급명 → 이 그룹 키 매핑)와 짝.
  tier: {
    rookie: { base: '#9a948a', ink: '#635e56', chip: '#f3f2ee' },
    silver: { base: '#88979f', ink: '#52616a', chip: '#eef1f2' },
    gold: { base: '#c2841a', ink: '#8c5f0d', chip: '#fbf2de' },
    platinum: { base: '#779aa9', ink: '#37616f', chip: '#eaf1f4' },
    diamond: { base: '#5b96cc', ink: '#2a6499', chip: '#e8f1f9' },
    master: { base: '#6f6a63', ink: '#2c2b28', chip: '#ecebe6' },
  },
  status: {
    success: '#2d8a6e',
    warning: '#c2841a',
    error: '#c43e3e',
    info: '#3cb7a0',
  },
  // 플랫폼 표식 — 플랫폼 소식(platform_news) 전용. 브랜드 색이라 brand/neutral 과 별개.
  platform: {
    youtube: '#d93025',
    naver: '#1ec800',
    kakao: '#f7d21e',
    kakaoInk: '#3c1e1e',
    instagram: '#e1306c',
    tiktok: '#111111',
    other: '#7a7670',
  },
  // 2026-09-06 토스트(시안 C, src/components/AppToast.jsx) 전용 — 상태 색을 면으로 깔 때의 연한 배경/테두리.
  // 글자는 항상 neutral.800 이므로 워시 위 본문 대비는 12:1 이상.
  statusWash: {
    success: '#e6f4ee',
    warning: '#fdf6e8',
    error: '#fbeded',
    info: '#e9f6f3',
  },
  statusLine: {
    success: '#bfe1d2',
    warning: '#ebd6a6',
    error: '#eec9c9',
    info: '#b8e3d9',
  },
  // 2026-09-11 레이 원탁(어드민 「레이 AI 도우미 › 원탁」) 전용 — 다섯 편·레이·프로그램·팀 B·사람 아바타 색.
  // 채택 시안 docs/design/lay-council-board-laeebly.html 의 --lay/--s1..s5/--sys/--b 값 그대로(대표 결정 2026-09-11 「레이블리 DS 적용판」).
  // 글자는 항상 흰색(아바타) 또는 neutral.800(본문) — 이 색을 본문 글자색으로 쓰지 않는다. `src/lib/layCouncil.js` 의 cls 키와 짝.
  council: {
    lay: '#c2841a',
    s1: '#6f5bd0',
    s2: '#d97b2a',
    s3: '#2f9e5b',
    s4: '#2b7bd6',
    s5: '#c43e3e',
    sys: '#7a7670',
    b: '#4a52b6',
    human: '#1a1918',
  },
  // 제작 사례 쇼룸(/showroom) — 원본 타임라인에서 쇼츠마다 칠하는 구간 색. 시안 docs/design/rights-shorts-showroom-variants.html 의 --s1..s5 그대로.
  // 다섯 편이 넘으면 순서대로 돌려 쓴다(`src/pages/showroom/Showroom.jsx` SEG_COLORS). 본문 글자색으로 쓰지 않는다.
  showroom: {
    s1: '#2a9a85',
    s2: '#b97c12',
    s3: '#c0533a',
    s4: '#4b5fc4',
    s5: '#6f8226',
  },
  // 작품 카드 조건 아이콘 6칸(2026-10-28 대표 결정 · 시안 C · src/components/work/ConditionIconStrip.jsx).
  // 해당하면 이 색(선 = 값 · 바탕 = bg · 테두리 = line), 해당 없으면 neutral 회색. 글자색 대비 4.5:1 이상(흰·bg 위).
  // 칸 순서·뜻은 src/lib/workConditionIcons.js — 색만 여기.
  condition: {
    inspection: '#b45309', inspectionBg: '#fbf0e6', inspectionLine: '#e8c4a3',
    geo: '#1d4ed8', geoBg: '#e9eefc', geoLine: '#b4c4f2',
    long: '#6d28d9', longBg: '#f1eafc', longLine: '#ccb5f2',
    shorts: '#be185d', shortsBg: '#f9e8ef', shortsLine: '#ebb3cb',
    bundle: '#c2410c', bundleBg: '#fbede6', bundleLine: '#edbfa6',
    bonus: '#a16207', bonusBg: '#f7f0e2', bonusLine: '#e3cf9f',
  },
};

export default colors;
